/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for check if an appointment exist for the same datetime and doctor
 * @export
 * @interface CheckAppointmentResponse
 */
export interface CheckAppointmentResponse {
    /**
     * true if exist
     * @type {boolean}
     * @memberof CheckAppointmentResponse
     */
    alreadyExist?: boolean;
}

/**
 * Check if a given object implements the CheckAppointmentResponse interface.
 */
export function instanceOfCheckAppointmentResponse(value: object): value is CheckAppointmentResponse {
    return true;
}

export function CheckAppointmentResponseFromJSON(json: any): CheckAppointmentResponse {
    return CheckAppointmentResponseFromJSONTyped(json, false);
}

export function CheckAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'alreadyExist': json['alreadyExist'] == null ? undefined : json['alreadyExist'],
    };
}

export function CheckAppointmentResponseToJSON(json: any): CheckAppointmentResponse {
    return CheckAppointmentResponseToJSONTyped(json, false);
}

export function CheckAppointmentResponseToJSONTyped(value?: CheckAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alreadyExist': value['alreadyExist'],
    };
}

